module.exports = __webpack_public_path__ + "img/ico22.780e2d97.jpg";